export const namespaced = true
import ApiActions from 'Services/actions'

export const state = {
  categories: null,
}

export const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
}

export const actions = {
  async load({ commit }) {
    try {
      const categories = await ApiActions.categories.get.categories()
      commit('SET_CATEGORIES', categories.data)
      return categories
    } catch (error) {
      return error
    }
  },
}
